import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import Button from "../../../components/button/Button";
import Utils from "../../../utils/Utils";
import Calendar from "../../../components/calendar/Calendar";
import RadioButton from "../../../components/radiobutton/RadioButton";
import $ from 'jquery';


class ExportArbovirosisNav extends Component {

    state = {
        tipoData: "",
        dataDa: "",
        dataA: ""
    }

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this)
    }

    componentDidMount() {
        let stato = this.props.filtri.stato

        if (stato) {

            stato["tipoData"] = ""

            $(document).ready(function () {
                $('.selectpicker').selectpicker('refresh')
            });
        }

    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState != this.state) {
            $(document).ready(function () {
                $('.selectpicker').selectpicker('refresh')
            });
        }
    }

    riceviValore(field, event) {
        let stato = this.props.filtri.stato

        if (event) {
            if (event.target.value === "true") {
                stato[field] = true
                this.setState({[field]: true})
            } else if (event.target.value === "false") {
                stato[field] = false
                this.setState({[field]: false})
            } else {
                stato[field] = event.target.value
                this.setState({[field]: event.target.value})
            }
        } else {
            stato[field.currentTarget.id] = [field.currentTarget.value];
        }

        this.props.filtri.setStatePadre({filtri: stato, sendRequest: false})

    }

    render() {

        return (
            this.props.filtri.rows ?
            <div className={"row"} style={{ paddingBottom:"1rem", width:"55%"}}>
                <div className={"col-6"}>
                    <p id={"title"} style={{fontWeight: "bold", marginTop: "1rem"}}>{"Periodo di riferimento"}</p>
                    <div className={"row"} style={{marginTop: "0.5rem"}}>
                        <div className={"col-6"}>
                            <Calendar id={this.props.filtri.rows["data"].id}
                                      value={this.state.dataDa}
                                      field={this.props.filtri.rows["data"].field}
                                      onChange={this.riceviValore}
                                      newCalendar={true}
                                      placeholder={this.props.filtri.rows["data"].placeholder ? this.props.filtri.rows["data"].placeholder : ""}
                                      errorMessage={this.state.dataDa && Utils.isDateInValid(this.state.dataDa) ? "Data non valida" : ""}
                                      error={Utils.isDateInValid(Utils.transformDateForBackend(this.state.dataDa), "-") &&
                                      this.state.dataDa !== ""} />
                        </div>
                        <div className={"col-6"}>
                            <Calendar id={this.props.filtri.rows["data"].id1}
                                      value={this.state.dataA}
                                      field={this.props.filtri.rows["data"].fieldRadio}
                                      onChange={this.riceviValore}
                                      newCalendar={true}
                                      placeholder={this.props.filtri.rows["data"].placeholder1 ? this.props.filtri.rows["data"].placeholder1 : ""}
                                      errorMessage={this.state.dataA && Utils.isDateInValid(this.state.dataA) ? "Data non valida" : ""}
                                      error={Utils.isDateInValid(Utils.transformDateForBackend(this.state.dataA), "-") &&
                                      this.state.dataA !== ""}/>

                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-6"}>
                            <RadioButton id={this.props.filtri.rows["tipoData"].id1}
                                         name={this.props.filtri.rows["tipoData"].name}
                                         label={"Data di inizio sintomi"}
                                         newRadio={true}
                                         onClick={this.riceviValore}
                                         style={{color: "black", fontSize: "16px", fontWeight: "bold"}}
                                         smallLabel={true}
                                         value={true}
                                         checked={this.state.tipoData === true}
                            ></RadioButton>
                        </div>
                        <div className={"col-6"}>
                            <RadioButton id={this.props.filtri.rows["tipoData"].id2}
                                         name={this.props.filtri.rows["tipoData"].name}
                                         label={"Data di segnalazione"}
                                         newRadio={true}
                                         onClick={this.riceviValore}
                                         style={{color: "black", fontSize: "16px", fontWeight: "bold"}}
                                         smallLabel={true}
                                         value={false}
                                         checked={this.state.tipoData === false}
                            ></RadioButton>
                        </div>
                    </div>
                </div>
                <div className={"col-6"} style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                    <Button className="btnBlu" id={"visualizza"}
                            text={"Richiedi export"}
                            onClick={this.props.filtri.applicaFiltri}
                            style={{height: "2rem", width: "15rem"}}>
                    </Button>
                </div>
            </div>: <></>
        );
    }

}

export default withTranslation('common')(ExportArbovirosisNav);
